import generate from 'firebase-auto-ids'
import _ from 'lodash'
import firebase from 'firebase'
import co from 'co'
import { auth, ref } from 'constants/firebase'
import * as integrationType from 'constants/integrationType'
import history from 'components/history'
import { publish } from 'controllers/logic'
import {
  SHOPIFY_ASSETS_URL,
  SHOPIFY_COLLECTION_PRODUCTS_URL,
  SHOPIFY_COLLECTIONS_BY_PRODUCT_URL,
  SHOPIFY_RECURRING_CHARGE_CREATE,
  SHOPIFY_PREVIEW_SMS_URL,
  SHOPIFY_ADD_WEBHOOK_URL,
  SHOPIFY_APP_UNINSTALLED_URL
} from 'constants'
import { displayError } from 'components/NotificationController'
import { store } from '../index'
import { receiveShopifyAssets, receiveShopifyCollectionProducts } from '../actions/shopifyAppDataAC'
import { initShopifyBar, initShopifyEmbeddedSDK, setShopifyBarLoadingOn } from './shopifyBar'
import { receiveShopifyAuth } from 'actions/shopifyAuthDataAC'
import { createDefaultCustomFields, getTemplateInfo } from 'templates/templates'
import { receiveShopifyPlans } from '../actions/shopifyPlansAC'
import { trackEvent } from 'utils/utils'

export function collectionsByProduct (productId, callback) {
  return function * (dispatch, getState) {
    const state = getState()
    const authToken = yield auth.currentUser.getIdToken()
    const url = `${SHOPIFY_COLLECTIONS_BY_PRODUCT_URL}&shopName=${state.user.shop}&token=${authToken}&productId=${productId}`
    const response = yield fetch(url)
    const resJson = yield response.json()
    console.log('collectionsByProduct response', resJson)
    if (resJson.error) {
      console.log('collectionsByProduct error', resJson.error)
    } else {
      callback(resJson)
    }
  }
}

function * productsByCollection (collectionId, shopName) {
  const authToken = yield auth.currentUser.getIdToken()
  const url = `${SHOPIFY_COLLECTION_PRODUCTS_URL}&shopName=${shopName}&token=${authToken}&collectionId=${collectionId}`
  const response = yield fetch(url)
  const resJson = yield response.json()
  console.log('productsByCollection response', resJson)
  if (resJson.error) {
    console.log('fetchShopifyAssets error', resJson.error)
    return null
  } else {
    store.dispatch(receiveShopifyCollectionProducts(collectionId, resJson.products))
    return resJson
  }
}

export function fetchProductsByCollection (collectionId) {
  return function * (dispatch, getState) {
    const state = getState()
    yield productsByCollection(collectionId, state.user.shop)
  }
}

export function * fetchShopifyAssets (shopName, app) {
  try {
    console.log('fetchShopifyAssets', shopName)
    const authToken = yield auth.currentUser.getIdToken()
    const url = `${SHOPIFY_ASSETS_URL}&shopName=${shopName}&token=${authToken}`
    const response = yield fetch(url)
    const resJson = yield response.json()
    console.log('fetchShopifyAssets response', resJson)
    if (resJson.error) {
      console.log('fetchShopifyAssets error', resJson.error)
      return null
    } else {
      const customCollections = {}
      for (const c of resJson.customCollection) {
        customCollections[c.id] = c
      }
      store.dispatch(receiveShopifyAssets(shopName, resJson.assets, resJson.texts, customCollections, resJson.videos))
      console.log('shopSettings received', resJson)
      return resJson
    }
  } catch (e) {
    console.log('fetchShopifyAssets error', e)
    return null
  }
}

function * createShopifyApp (user, shopSettings) {
  console.log('createShopifyApp')
  const app = {
    id: generate(_.now()),
    name: user.shop,
    createdAt: firebase.database.ServerValue.TIMESTAMP,
    templateId: 'outSide',
    slidesCnt: 2
  }

  const templateInfo = getTemplateInfo(app.templateId)
  console.log('templateInfo', templateInfo)
  if (templateInfo.defaultSlides) {
    console.log('defaultSlides', templateInfo.defaultSlides)
    const defaultCF = createDefaultCustomFields(app.templateId, app.slidesCnt)
    console.log('defaultCF', defaultCF)
    app.customFields = defaultCF
  }

  if (shopSettings.customCollection.length > 0 && app.customFields.showcases.length > 0) {
    const sortedCollections = _.orderBy(shopSettings.customCollection, c => c.image ? c.image.height : 0, ['desc'])
    for (const showcaseNum in app.customFields.showcases) {
      const collection = _.get(sortedCollections, showcaseNum, sortedCollections[0])
      const collectionProductsInfo = yield productsByCollection(collection.id, user.shop)
      console.log('showcaseNum', showcaseNum, 'collection', collection, 'products', collectionProductsInfo.products)
      if (collectionProductsInfo.products.length > 0) {
        const p0 = collectionProductsInfo.products[0]
        _.set(app, ['customFields', 'showcases', showcaseNum, 'products', 0, 'productId'], p0.id)
        _.set(app, ['customFields', 'showcases', showcaseNum, 'products', 0, 'title'], p0.title)
        const p1 = collectionProductsInfo.products[1]
        if (p1) {
          _.set(app, ['customFields', 'showcases', showcaseNum, 'products', 1, 'productId'], p1.id)
          _.set(app, ['customFields', 'showcases', showcaseNum, 'products', 1, 'title'], p1.title)
        } else {
          const showcase = app.customFields.showcases[showcaseNum]
          _.set(app, `customFields.customStyles.ou_showcase_link_p${showcase.slideId}_1.HIDDEN.value`, true)
        }

        _.set(app, ['customFields', 'showcases', showcaseNum, 'name'], _.get(collection, 'title', null))
        _.set(app, ['customFields', 'showcases', showcaseNum, 'image'], _.get(collection, 'image.src', null))
      }
    }
  }

  let logoUrl
  for (const asset of shopSettings.assets) {
    if (asset.key === 'logo') logoUrl = asset.url
  }
  if (logoUrl) _.set(app, 'customFields.splash.logo', logoUrl)

  let subheading = 'Whimm Splash Pages'
  for (const t of shopSettings.texts) {
    if (t.location === 'headerText') subheading = t.value
  }
  _.set(app, 'customFields.splash.title', subheading)

  if (user.shop) {
    _.set(app, 'customFields.appSettings.integration.type', integrationType.SHOPIFY)
    _.set(app, 'customFields.appSettings.integration.shopName', user.shop)
  }

  // last scene
  _.set(app, 'customFields.lastScene.title', subheading)
  _.set(app, 'customFields.lastScene.subtitle', '')
  _.set(app, 'customFields.customStyles.ou_share__main-button.HIDDEN.value', true)
  let heroTitle = ''
  for (const t of shopSettings.texts) {
    if (t.location === 'heroTitle') heroTitle = t.value
  }
  _.set(app, 'customFields.lastScene.author', heroTitle)

  // video scene
  // if (shopSettings.videos.length > 0) {
  //   const url = shopSettings.videos[0]
  //   _.set(app, 'customFields.door.video.url', url)
  // } else {
  //   _.set(app, 'customFields.appSettings.skipSlides.0', 'videoScene')
  // }

  _.set(app, 'customFields.appSettings.skipSlides.0', 'videoScene')

  // redirect to the original store
  _.set(app, 'customFields.appSettings.redirectUrl', `https://${user.shop}.myshopify.com`)
  _.set(app, 'customFields.appSettings.autoRedirectEnabled', true)

  console.log('create app', app)

  yield ref.child('users').child(user.id).child('apps').child(app.id).set(app)
  return app
}

function fetchShopifyPlans () {
  return function * (dispatch) {
    const plansSN = yield ref.child('shopifyPlans').once('value')
    const plans = plansSN.val()
    if (plans) dispatch(receiveShopifyPlans(plans))
  }
}

function addWebhook (params) {
  return function * () {
    const url = `${SHOPIFY_ADD_WEBHOOK_URL}&topic=${params.topic}&url=${params.url}&shopName=${params.shopName}`
    yield fetch(url)
  }
}

function setupWebhooks (user) {
  co(addWebhook({shopName: user.shop, topic: 'app/uninstalled', url: encodeURIComponent(`${SHOPIFY_APP_UNINSTALLED_URL}?shopName=${user.shop}&userId=${user.id}`)}))
  // co(addWebhook({shopName: user.shop, topic: 'orders/create', url: encodeURIComponent(`${SHOPIFY_APP_ORDER_EVENT_URL}?shopName=${user.shop}&userId=${user.id}`)}))
  // co(addWebhook({shopName: user.shop, topic: 'orders/paid', url: encodeURIComponent(`${SHOPIFY_APP_ORDER_EVENT_URL}?shopName=${user.shop}&userId=${user.id}`)}))
}

export function initShopifyApp (params) {
  return function * (dispatch, getState) {
    dispatch(receiveShopifyAuth({
      apiKey: params.api_key,
      shopUrl: params.shop_url
    }))
    initShopifyEmbeddedSDK(params.api_key, params.shop_url)
    setShopifyBarLoadingOn()
    const authData = yield auth.signInWithCustomToken(params.token)
    const userSN = yield ref.child('users').child(authData.uid).once('value')
    console.log('======> user received', Date.now())
    const user = userSN.val()
    if (user) {
      FS.identify(user.id, { // eslint-disable-line no-undef
        displayName: user.shop,
        email: user.email
      })
      mixpanel.identify(user.id) // eslint-disable-line no-undef
      console.log('usser testGroup ', user.testGroup)
      if (user.testGroup) mixpanel.register({testGroup: user.testGroup})// eslint-disable-line no-undef
      mixpanel.register({email: user.email, shop: user.shop, charged: user.charged})// eslint-disable-line no-undef
      mixpanel.people.set({ // eslint-disable-line no-undef
        '$first_name': user.shop,
        '$created': new Date(user.createdAt).toISOString(),
        '$email': user.email
      })

      dispatch(fetchShopifyPlans())
      setupWebhooks(user)

      if (history.location.pathname === '/shopify-app/charge-declined') {
        return
      }
      if (_.has(user, 'apps')) {
        const ids = _.keys(user.apps)
        const appId = ids[0]
        console.log('======> redirect to dashboard', Date.now())
        co(fetchShopifyAssets(user.shop))
        gotoDashboard(appId)
      } else {
        const shopSettings = yield fetchShopifyAssets(user.shop)
        const app = yield createShopifyApp(user, shopSettings)
        gotoEditor(app.id)
      }
    } else {
      console.error('user is not created yet')
    }
  }
}

export function publishAndActivate (appId) {
  return function * (dispatch, getState) {
    const state = getState()
    const app = _.get(state.apps, appId)
    if (!auth.currentUser.isAnonymous) {
      dispatch(publish(app, false))
      try {
        console.log('SHOPIFY_RECURRING_CHARGE_CREATE')
          // TODO: maybe some loading indicator?
        const authToken = yield auth.currentUser.getToken()
        const chargesUrl = `${SHOPIFY_RECURRING_CHARGE_CREATE}&authToken=${authToken}`
        const response = yield fetch(chargesUrl)
        const resJson = yield response.json()
        console.log('resJson', resJson)
        if (resJson.redirect_to) {
          console.log('redirect to confirmation')
          window.top.location.href = resJson.redirect_to
        } else if (resJson.status === 'ok') {
          gotoDashboard()
        }
      } catch (e) {
        console.log('publishAndActivate error', e)
        displayError(`Error: ${e.message}`)
      }
    }
  }
}

export function gotoEditor (appId) {
  const url = `/shopify-app/${appId}`
  console.log('goto', url)
  initShopifyBar()
  trackEvent('Enter editor')
  history.push(url)
}

export function gotoDashboard () {
  trackEvent('Enter dashboard')
  history.push(`/shopify-app/dashboard`)
}

export function gotoChargeDeclinedPage (userId) {
  trackEvent('Enter charge declined page')
  ref.child('users').child(userId).child('status').set('deactivated')
  history.push(`/shopify-app/charge-declined`)
}

export function sendPreviewSms (toNumber, onSent) {
  return function * (dispatch, getState) {
    const state = getState()
    const apps = _.values(state.apps)
    try {
      if (apps.length > 0) {
        const app = apps[0]
        const pName = `preview_${app.name}`
        dispatch(publish(app, false, pName))
        const user = state.user
        const authToken = yield auth.currentUser.getIdToken()
        const url = `${SHOPIFY_PREVIEW_SMS_URL}&shopName=${user.shop}&token=${authToken}&toNumber=${encodeURIComponent(toNumber)}`
        trackEvent('Send preview SMS')
        const response = yield fetch(url)
        const resJson = yield response.json()
        console.log('resJson', resJson)
        if (resJson === 'OK') {
          onSent(true)
        } else {
          onSent(false)
        }
      } else {
        onSent(false)
      }
    } catch (e) {
      onSent(false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/shopifyApp.js